// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2lgkF","test":"Button_test__3hkRv"};